module.exports = __webpack_public_path__ + "img/flora_skincareoil_202307.5e9cd223.jpg";